
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.064 14.713c0-.02.036-.1.106-.234a259.536 259.536 0 001.23-2.465L4.78 9.24c.064-.117.139-.176.222-.176.075 0 .13.024.164.07.034.048.129.229.285.544.08.153.145.28.192.379l2.261 4.527c.026.065.04.108.043.129 0 .052-.045.078-.136.078H2.275c-.14 0-.21-.026-.21-.078zm.528-.531h4.304l-2.152-4.32-2.152 4.32zM.97 18.267v-.91h8.423v.91H.97zm0 2.837v-.91h8.423v.91H.97z","fill":"currentColor"}})])
          )
        }
      }
    